import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const putChangeVisualValidationCrosstableData = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  dataObjectVersionId: number;
}) =>
  apiClient
    .put<{
      externalCode: string;
    }>(
      expand(ValidationDashboardUrl.CROSSTABLE_CHANGE_DATA, { externalCode }),
      data,
    )
    .then((response) => response.data);

export const useChangeVisualValidationCrosstableDataMutation =
  createApiMutationHook(
    ['changeVisualValidationCrosstableData'],
    putChangeVisualValidationCrosstableData,
  );
